import React, { FC } from 'react'
import { ChatContextProvider } from './context/ChatContext'
import { useLocation, useParams } from 'react-router-dom'
import { useDesktopBreakpoint } from '../theme/useDesktopBreakpoint'
import { ChatDesktop } from './desktop/ChatDesktop'
import { ChatMobile } from './mobile/ChatMobile'
import { ChatState } from './state/ChatState'
import { ChatLocationState } from './types/ChatLocationState'
import { PreviewEditsContextProvider } from '../features/preview-edits/model/PreviewEditsContext'

export const Chat: FC = () => {
  const { chatId } = useParams() as { chatId: string }
  const { state } = useLocation() as { state: ChatLocationState | null }
  const desktopBreakpoint = useDesktopBreakpoint()
  const isChatLocked = state?.isChatLocked ?? false

  return (
    <ChatContextProvider chatId={chatId} key={chatId}>
      <PreviewEditsContextProvider isChatLocked={isChatLocked}>
        {desktopBreakpoint ? <ChatDesktop /> : <ChatMobile />}
      </PreviewEditsContextProvider>

      <ChatState />
    </ChatContextProvider>
  )
}
